/* eslint-disable react/jsx-sort-props */
import * as React from 'react';
import * as vars from '../../styles/variables';
import AccessibleSVG, { SVGProps } from '../../components/accessible-svg/AccessibleSVG';

/**
 * This is an auto-generated component and should not be edited
 * manually in contributor pull requests.
 *
 * If you have problems with this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Bug_report.md
 *
 * If there are missing features in this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Feature_request.md
 */

const FileBoxNote16 = (props: SVGProps) => (
    <AccessibleSVG width={16} height={16} viewBox="0 0 16 16" {...props}>
        <path
            fill={vars.bdlGray50}
            fillRule="evenodd"
            d="M11.482 4.641l.052.091c.074.115.235.323.538.542.456.328.797.374.797.374l-4.64 6.72a2.62 2.62 0 01-.461.483l-1.373 1.036c-.146.11-.234.055-.193-.14l.372-1.763c.04-.187.156-.461.267-.623l4.64-6.72zM6.23 11.05l-.424.635a2.164 2.164 0 00-.229.494l-.031.118-.028.127H2.69a.687.687 0 110-1.374h3.541zm2.148-3.438l-.92 1.375H2.697A.69.69 0 012 8.3c0-.38.31-.688.697-.688H8.38zm2.147-3.437l-.92 1.375h-6.92a.688.688 0 01.002-1.375h7.839zm2.963-.977c.373.272.407.704.407.704a3.533 3.533 0 01-.314.607l-.28.417-.09-.016a1.732 1.732 0 01-.632-.282c-.35-.255-.628-.687-.628-.687l.28-.418c.106-.158.284-.397.448-.51l.074-.009c.14-.012.456-.01.735.194z"
        />
    </AccessibleSVG>
);

export default FileBoxNote16;
